import React from 'react';
import styled from 'styled-components';
import chroma from 'chroma-js';
import { Label } from 'reactstrap';

import { primaryColor } from 'js/config/style';
const backgroundColor = chroma('white');

export default styled(({ isChecked, ...rest }) => <Label {...rest} />)`
  text-align: center;
  font-size: 1rem;
  cursor: pointer;
  display: grid;
  grid-template-rows: 50px auto;
  background: ${backgroundColor.hex()};
  border-radius: 0.5rem;
  border: 1px solid ${({ isChecked }) => (isChecked ? primaryColor.hex() : 'transparent')};
  padding: 1rem 0;

  &:hover {
    border-color: ${({ isChecked }) => (isChecked ? primaryColor.hex() : backgroundColor.darken().hex())};
  }
`;
